export default __webpack_public_path__ + "static/media/forklift.c725f54e.svg";